import React from 'react'
import AOS from "aos"; // Import AOS library
import CustomHelmet from '../components/CustomHelmet'
import FaqSec from '../sections/faq/FaqSec'
import { t } from 'i18next'
import Banner from '../components/Banner'

const Faq = () => {

    React.useEffect(() => {
        AOS.init();

    }, []);
    return (
        <>
            <CustomHelmet
                title={"Exclusive Real Estate Across Egypt"}
                desc={'Connect Homes makes exploring real estate in Egypt simple and seamless.'}
            />
            <Banner
                title={t("faq")}
                desc={t("banner_desc")}
            ></Banner>
            <FaqSec />
        </>
    )
}

export default Faq